import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Loader from "react-spinners/ScaleLoader";
const SScaleLoader = ({ color, ...props })=>{
    return /*#__PURE__*/ _jsx(Loader, {
        color: color || "rgba(255,255,255,0.2)",
        ...props
    });
};
export default SScaleLoader;
